module.exports = __webpack_public_path__ + "img/cww_15.2bd5b4d9.jpg";